import React from "react";

import { makeStyles, useTheme } from "@mui/styles";

import {
  AppBar,
  Card,
  CardContent,
  Container,
  Grid,
  Toolbar,
  Typography,
} from "@mui/material";
import logo from "../assets/Logo.png";
import { Box } from "@mui/system";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  logo: {
    marginRight: theme.spacing(1),
    marginLeft: "auto",
    marginRight: "auto",
    height: "80px",
    animation: "$rotate 3s alternate  ", // add animation
  },
  "@keyframes rotate": {
    // define animation
    "0%": {
      transform: "rotate(0deg)",
    },
    "100%": {
      transform: "rotate(360deg)",
    },
  },
}));

const Header = () => {
  const theme = useTheme();
  const classes = useStyles();
  const isMobile = theme.breakpoints.down("sm");
  return (
    <div className={classes.root}>
      <AppBar position="static" elevation={0}>
        <Toolbar>
          <img src={logo} alt="Foshizi" className={classes.logo} />
        </Toolbar>
      </AppBar>
      <Box height={10} />

      <Container maxWidth="md">
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Card
              sx={{
                boxShadow: "0px 4px 10px grey ",
                background: "#263859",
                color: "white",
              }}
            >
              <CardContent>
                <Typography
                  variant="h3"
                  component="h1"
                  align="center"
                  className={classes.text}
                  style={{ fontSize: isMobile ? "1.8rem" : "15rem" }}
                >
                  Welcome to Foshizi!
                </Typography>
                <Typography
                  variant="body1"
                  marginTop={3}
                  className={classes.paragraph}
                  style={{ fontWeight: isMobile ? "2rem" : "15rem" }}
                >
                  My name is USERNAME and I work for Foshizi, an independent
                  market research agency. We are currently conducting a research
                  aimed at understanding consumer shopping behaviour for
                  different products which include cabinet material and beds.
                  This research will further explore your views with regards to
                  litter and recycling.
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </Container>
      <Box height={10} />
    </div>
  );
};

export default Header;
